export default __webpack_public_path__ + "static/media/DSC_0546.92258e5a.webp";